import { Stack } from 'expo-router';

export default function OnboardLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen
        name="medical-aid"
        options={{
          title: 'Patients',
        }}
      />
      <Stack.Screen
        name="private"
        options={{
          title: 'Patient',
        }}
      />
    </Stack>
  );
}
